import type { SongCard } from '@/types/content'

export interface Track {
    id: string
    slug: string
    title: string
    subtitle: string | null
    cover: string | null
    cover_alt: string | null
    src: string
    is_demo: boolean
    duration: number | null
}

type TrackSource = Pick<SongCard, 'id' | 'slug' | 'title' | 'subtitle' | 'cover' | 'cover_alt' | 'is_demo' | 'duration_seconds'>

/** Every track streams through the site itself, so the original file address is never exposed. */
export const toTrack = (song: TrackSource): Track => ({
    id: song.id,
    slug: song.slug,
    title: song.title,
    subtitle: song.subtitle,
    cover: song.cover,
    cover_alt: song.cover_alt,
    src: `/api/audio/${song.id}`,
    is_demo: song.is_demo,
    duration: song.duration_seconds
})

export const playableTracks = (songs: Array<SongCard>): Array<Track> => songs.filter(song => song.has_audio).map(toTrack)

export const isTrack = (value: unknown): value is Track => {
    if (!value || typeof value !== 'object') return false

    const track = value as Record<string, unknown>

    return typeof track.id === 'string' && typeof track.slug === 'string' && typeof track.title === 'string' && typeof track.src === 'string' && track.src.startsWith('/api/audio/')
}
